import * as Config from '../../../config';
import React, { useState, useCallback, useEffect, useRef } from 'react';
import { useDispatch } from "react-redux";
import PropTypes from 'prop-types';
import { debounce } from "throttle-debounce";
import { MenuItem } from "react-contextmenu";
import './FilterInput.css';
import dayjs from 'dayjs';

import { showMenu } from 'react-contextmenu/modules/actions';
import { setContextMenu } from "../../../actions/index";

function FilterDate({ flexShrink, type, placeholder, value, onValid }) {
  const elInput = useRef();
  const dispatch = useDispatch();
  const [val, setVal] = useState(value);
  const [focus, setFocus] = useState(false);
  const forceFocus = () => {
    if (Config.TOUCH_ENABLED) {
      elInput.current.focus()
    }
  }

  useEffect(() => { setVal(value) }, [value])

  const debouncedApply = useCallback(debounce(1000, (v) => {
    onValid(type, v)
  }), [])
  const search = (value) => {
    setVal(value);
    debouncedApply(value);
  }
  const onChange = (e) => { search(e.target.value) }
  const onClear = () => { search(``) }

  const selectDate = (date) => () => { search(date) };
  const showContextMenu = () => {
    const list = [
      {label: 'Today', value: `${dayjs().format(`YYYY-MM-DD`)}:${dayjs().format(`YYYY-MM-DD`)}` },
      {label: 'Yesterday', value: `${dayjs().subtract(1, 'day').format(`YYYY-MM-DD`)}:${dayjs().subtract(1, 'day').format(`YYYY-MM-DD`)}`},
      {label: 'Last 7 days', value: `${dayjs().subtract(7, 'day').format(`YYYY-MM-DD`)}:${dayjs().format(`YYYY-MM-DD`)}`},
      {label: 'Last 30 days', value: `${dayjs().subtract(30, 'day').format(`YYYY-MM-DD`)}:${dayjs().format(`YYYY-MM-DD`)}`},
    ]
    const content = list.map((x,i) => <MenuItem 
      key={`date-filter-{i}`} o
      onClick={selectDate(x.value)} 
      data={{ action: x.label }}>
      <div className={'flexRow block-contextmenu-item'}>
        {x.label}
      </div>
    </MenuItem>);
    dispatch(setContextMenu(content, {className: 'dynamic-menu-row-menu'}));
    const p = elInput.current.getBoundingClientRect();
    showMenu({
      position: {x: p.left + 90, y: p.top + p.height + 15},
      target: {},
      id: `DynamicMenu`
    })
  }

  const prepareFocus = () => {
    setFocus(true);
    showContextMenu();
  }
  const prepareBlur = () => {
    setFocus(false);
  }

  return (
    <div className={`flexRow align filter-container ${(value.length > 0) && `extend`} ${focus && `focus`} ${flexShrink > 1 && `small`} `}
      style={{ flexShrink }}
      tabIndex={0}
      onFocus={prepareFocus}
      onBlur={prepareBlur}
    >
      <input ref={elInput} type="text" onChange={onChange} value={val}
        placeholder={placeholder} onFocus={prepareFocus} onBlur={prepareBlur}
        onClick={forceFocus} className={`filter-input-v2`}
      />
        { (value.length > 0) && (
          <div className="type-small brand-primary button-clear" onClick={onClear}>
            <span>Clear</span>
          </div>
        )}
    </div>
  )
}

FilterDate.propTypes = {
  placeholder: PropTypes.string,
  value: PropTypes.string.isRequired,
  onValid: PropTypes.func.isRequired
}

export default FilterDate;
